import $ from "jquery";


export default function onResizeWindow() {


    window.addEventListener("resize", function (e) {
        if(window.innerWidth <= 991) {
            $(".edv-nav-desktop").attr("aria-hidden","true");
            $(".edv-nav-mobile").attr("aria-hidden","false");
            $(".edv-services-template-nav-desktop").attr("aria-hidden","true").addClass('d-none');
            $(".edv-services-template-nav-mobile").attr("aria-hidden","false").removeClass('d-none');
        }
        if(window.innerWidth > 991) {
            $(".edv-services-template-nav-desktop").attr("aria-hidden","false").removeClass('d-none');
            $(".edv-services-template-nav-mobile").attr("aria-hidden","true").addClass('d-none');
            $(".edv-nav-desktop").attr("aria-hidden","false");
            $(".edv-nav-mobile").attr("aria-hidden","true");
        }


    });


}